import { render, staticRenderFns } from "./ImagenesTable.vue?vue&type=template&id=79a2a2e4"
import script from "./ImagenesTable.vue?vue&type=script&lang=js"
export * from "./ImagenesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports